import React, { useEffect, useState } from "react";

import PCTemplate from "../../components/pc-template";
import MobileVersion from "../../components/mobile-version";
import Footer from "../../components/footer";

import { FloatButton } from "antd";

const Home: React.FC = () => {
  const [showAIButton, setShowAIButton] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 1000 && scrollPosition <= 3400) {
        setShowAIButton(true);
      } else {
        setShowAIButton(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {windowWidth > 820 ? <PCTemplate /> : <MobileVersion />}
      <Footer />
      <div
        className={`w-24 h-28 fixed right-12 top-52 z-50 cursor-pointer transition-transform duration-1000 ${
          showAIButton ? "translate-x-0" : "translate-x-[500%]"
        }`}
        onClick={() => (window.location.href = "/ai-planner")}
      >
        <div
          className={`scale-95 rounded-[30px] w-full h-full ${
            hovered ? "bg-[#f65600]" : "bg-[#fef8f6]"
          }   ai_shadow flex flex-col justify-center items-center`}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img
            src={
              hovered
                ? "/icon/ai-travel-agent2.png"
                : "/icon/ai-travel-agent.png"
            }
            alt=""
            className="w-12 h-12"
          />
          <span
            className={`
              ${hovered ? " text-[#fbf0ed]" : "text-[#f65600] "}
              text-base font-bold text-center
            `}
          >
            AI Travel Agent
          </span>
        </div>
      </div>

      <FloatButton.BackTop />
    </>
  );
};

export default Home;
